// constants/breakpoints.ts
// these values follow tailwind's default breakpoints
export const BREAKPOINTS = {
  'SM': 640, // Tailwind 'sm'
  'MD': 768, // Tailwind 'md'
  'LG': 1024, // Tailwind 'lg'
  'XL': 1280, // Tailwind 'xl'
  '2XL': 1536, // Tailwind '2xl'
} as const

// semantic names for readability
export const DEVICE_BREAKPOINTS = {
  MOBILE: BREAKPOINTS.SM,
  TABLET: BREAKPOINTS.MD,
  DESKTOP: BREAKPOINTS.LG,
  LARGE_DESKTOP: BREAKPOINTS.XL,
  EXTRA_LARGE_DESKTOP: BREAKPOINTS['2XL'],
} as const
